module.exports = __webpack_public_path__ + "media/Video 3b.24d68f8a.mp4";